import React from 'react';
import styles from './SubmissionConfirmation.module.sass';

function SubmissionConfirmation() {
  return (
    <div className={styles['submission-confirmation']}>
      <strong>
        Your application form for the Volition & Creator Brands Accelerator has been submitted.
      </strong>
      <p>
        We’ll be in contact with you shortly!
      </p>
      <p>
        Please contact
        {' '}
        <a href="mailto:service@creatorbrandco.com">service@creatorbrandco.com</a>
        {' '}
        for any questions or status of your application

      </p>
    </div>
  );
}

export default SubmissionConfirmation;
